import React, {Component} from "react";
import classNames from "classnames";

const checkIcon = require("../../resources/img/anywhere/check.svg");

interface Props {
    loading: boolean;
    onCodeRequest: () => void;
    onSurveyAccess: () => void;
    onSurveySkip: () => void;
    betaUserApproved: boolean;
}

export default class LunaSteps extends Component<Props> {
    render(): JSX.Element {
        let button: JSX.Element;

        if (this.props.betaUserApproved) {
            button = (
                <>
                    <button className="btn" onClick={this.props.onSurveyAccess}>
                        Fill out survey
                    </button>

                    <button className="btn__link" onClick={this.props.onSurveySkip}>
                        I already filled out the survey
                    </button>
                </>
            );
        } else {
            button = (
                <button
                    className={classNames({
                        btn: true,
                        btn__disabled: this.props.loading,
                        btn__loading: this.props.loading,
                    })}
                    disabled={this.props.loading}
                    onClick={this.props.onCodeRequest}
                >
                    {!this.props.loading && <>Request Code</>}
                    {this.props.loading && <>Retrieving Code</>}
                </button>
            );
        }

        return (
            <>
                <h2>How to access Ubisoft+ on Luna</h2>

                <div className="anywhereTab__cards__list">
                    <div className={classNames({
                        "list-item": true,
                        "code-request": true,
                        "active": this.props.betaUserApproved,
                    })}>
                        <p>Request your unique code to receive it in an email</p>
                        <img src={checkIcon} alt="Checkmark" />
                    </div>

                    <div className="list-item survey">
                        <p>Fill out the Luna early access survey with your code</p>
                    </div>

                    <div className="list-item wait">
                        <p>Wait to receive your Luna early access invitation (issued on a rolling basis)</p>
                    </div>

                    <div className="list-item link">
                        <p>Accept your Luna invitation and link your Ubisoft account</p>
                    </div>
                </div>

                {
                    this.props.betaUserApproved &&
                        <p className="success">
                            <span>Your code was sent!</span> Please check your email and fill out the Luna early access survey with your code.
                        </p>
                }

                {button}
            </>
        );
    }
}